import { SET_SETTINGS, SET_SETTING_VALUE } from "./actions";

export default {
  [SET_SETTINGS](state, settings) {
    state.settings = settings;
  },
  [SET_SETTING_VALUE](state, { key, value, description }) {
    const setting = state.settings.find((s) => s.key === key);
    if (setting) {
      setting.value = value;
      if (description !== undefined) {
        setting.description = description;
      }
    }
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_SAVING(state, isSaving) {
    state.isSaving = isSaving;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
